import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
  Paper,
  Stack,
  Box,
  Typography,
  InputLabel,
} from "@mui/material";
import Swal from "sweetalert2";
import { mostrarToast } from "../utils/toastUtils";
import SucursalesService from "../services/SucursalesService";

const Sucursales = () => {

  useEffect(() => {
    document.title = "Sucursales";
  }, []);

  const navigate = useNavigate();
  const [sucursalesOriginal, setSucursalesOriginal] = useState([]);
  const [sucursalesActivos, setSucursalesActivos] = useState([]);

  const getData = async () => {
    const resultado = await SucursalesService.getSucursales();
    setSucursalesOriginal(resultado.data.sucursales);
    setSucursalesActivos(resultado.data.sucursales);
  };
  useEffect(() => {
    getData();
  }, []);

  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
    if (typeof getData === "function") {
      getData();
    }
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  const [nombre, setNombre] = useState("");

  const handleBuscar = async (valorNombre) => {
    const valor = valorNombre.trim();
    if (valor === "") {
      setSucursalesActivos([...sucursalesOriginal]);
      return;
    }

    try {

      const resultado = await SucursalesService.buscarSucursales(valor);
      setSucursalesActivos(resultado.sucursales);
    } catch (error) {
      console.error("Error en búsqueda:", error);
    }
  };

  const handleMostrarTodos = () => {
    getData();
    setNombre("");
  };

  const handleDuplicar = (sucursal) => {
    navigate(`/duplicarSucursal/${sucursal.idSucursal}`, { state: { fromApp: true } });
  };

  const handleEditar = (sucursal) => {
    navigate(`/editarSucursal/${sucursal.idSucursal}`, { state: { fromApp: true } });
  };

  const handleEliminar = (sucursal) => {
    Swal.fire({
      title: "¿Eliminar sucursal?",
      text: `¿Desea eliminar la sucursal ${sucursal.nombre}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await eliminarSucursal(sucursal.idSucursal);
      }
    });
  };

  const eliminarSucursal = async (sucursalId) => {
    try {
      const resultado = await SucursalesService.deleteSucursal(sucursalId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Sucursal eliminada con éxito!");
      } else {
        mostrarError("Error al eliminar sucursal");
      }
    } catch (error) {
      console.error("Error al eliminar sucursal:", error);
      mostrarError("Error al eliminar sucursal");
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "80vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 4,
                mb: 3,
                backgroundColor: "#f6f8fb",
                width: "64vw",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h7"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(90deg, #006787, #014e65)",
                  color: "white",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  display: "inline-block",
                  marginBottom: "2vh",
                  fontWeight: "bold"
                }}
              >
                BUSCAR SUCURSAL
              </Typography>
              <Stack direction="row" spacing={2} alignItems="center">
                <InputLabel
                  htmlFor="txfNombre"
                  sx={{
                    color: "black",
                    fontSize: "1vw",
                    width: "12vw",
                    height: "38px",
                    fontWeight: "bold"
                  }}
                >
                  Nombre de la sucursal:
                </InputLabel>
                <TextField
                  value={nombre}
                  onChange={(e) => {
                    setNombre(e.target.value);
                    handleBuscar(e.target.value);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "38px",
                      width: "25vw",
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "1vw",
                      padding: "0.5vw",
                    },
                  }}
                  className="txfNombre"
                />
                <Button
                  id="btnMostrarTodos"
                  variant="contained"
                  onClick={handleMostrarTodos}
                  sx={{
                    backgroundColor: "#006787",
                    width: "12vw",
                    height: "38px",
                    fontWeight: "bold"
                  }}
                >
                  Mostrar todas
                </Button>
              </Stack>
            </Paper>

            <Paper
              elevation={3}
              sx={{
                borderRadius: 4,
                overflow: "hidden",
                width: "65vw",
                p: 2,
                backgroundColor: "#f6f8fb",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                {" "}

                <TableHead sx={{ backgroundColor: "#18234f" }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Nombre
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Estatus
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Editar
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Eliminar
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Duplicar
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sucursalesActivos.length > 0 ? (
                    sucursalesActivos.map((sucursal) => (
                      <TableRow key={sucursal.idSucursal}>
                        <TableCell>{sucursal.nombre}</TableCell>
                        <TableCell>{sucursal.estatus === "A" ? "Activo" : "Inactivo"}</TableCell>
                        <TableCell>
                          <Button
                            size="large"
                            sx={{ color: "orange" }}
                            onClick={() => handleEditar(sucursal)}
                          >
                            <EditIcon sx={{ fontSize: "1.5vw" }} />
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button
                            size="large"
                            sx={{ color: "red" }}
                            onClick={() => handleEliminar(sucursal)}
                          >
                            <DeleteIcon sx={{ fontSize: "1.5vw" }} />
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button
                            size="large"
                            sx={{ color: "#18234f" }}
                            onClick={() => handleDuplicar(sucursal)}
                          >
                            <ControlPointDuplicateIcon sx={{ fontSize: "1.5vw" }} />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                        No hay registros
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Stack>
        </Box>
      </Content>
    </Layout>
  );
};

export default Sucursales;
